/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Confirm_Password_LabelInputs */

const en_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Password`)
};

const fr_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer le Mot de Passe`)
};

const de_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort bestätigen`)
};

const it_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma password`)
};

const ru_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердите пароль`)
};

const es_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`confirmar Contraseña`)
};

const zh_cn2_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认密码`)
};

const ja_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードを認証する`)
};

const hi_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड की पुष्टि कीजिये`)
};

const pt_pt2_login_confirm_password_label = /** @type {(inputs: Login_Confirm_Password_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirme sua senha`)
};

/**
* | output |
* | --- |
* | "Confirm Password" |
*
* @param {Login_Confirm_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_confirm_password_label = /** @type {((inputs?: Login_Confirm_Password_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Confirm_Password_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_confirm_password_label(inputs)
	if (locale === "de") return de_login_confirm_password_label(inputs)
	if (locale === "it") return it_login_confirm_password_label(inputs)
	if (locale === "ru") return ru_login_confirm_password_label(inputs)
	if (locale === "es") return es_login_confirm_password_label(inputs)
	if (locale === "zh-CN") return zh_cn2_login_confirm_password_label(inputs)
	if (locale === "ja") return ja_login_confirm_password_label(inputs)
	if (locale === "hi") return hi_login_confirm_password_label(inputs)
	if (locale === "pt-PT") return pt_pt2_login_confirm_password_label(inputs)
	return en_login_confirm_password_label(inputs)
});